import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { VpAsset, VpAssetName, VpIcon } from '@vtmn-play/react'

type TopBarProps = {
  variant: 'light' | 'dark'
  title: string
  subtitle?: string
  hideNavigationButtons?: boolean
}

const TopBar = ({ variant, title, subtitle, hideNavigationButtons = false }: TopBarProps) => {
  const { t } = useTranslation('common')
  const { assetName, titleColor, subtitleColor, headerBg, accountColor } =
    variant === 'dark'
      ? {
          assetName: 'logo-decathlon-core-symbol-white',
          titleColor: 'text-white',
          subtitleColor: 'text-white/80',
          headerBg: 'bg-primary-blue',
          accountColor: 'white',
        }
      : {
          assetName: 'logo-decathlon-core-symbol-brand',
          titleColor: 'text-subtitleM',
          subtitleColor: 'text-gray-500',
          headerBg: '',
          accountColor: 'text-primary-blue',
        }

  return (
    <header className={`sticky h-16 flex items-center justify-between px-4 ${headerBg}`}>
      <div className="flex items-center justify-center">
        {!hideNavigationButtons && (
          <Link to="/" viewTransition>
            <VpAsset name={assetName as VpAssetName} width={32} />
          </Link>
        )}
      </div>
      <div className="flex flex-col items-center justify-center">
        <h1 className={`font-medium ${titleColor}`}>{t(title)}</h1>
        {subtitle && <p className={`text-xs mt-1 ${subtitleColor}`}>{t(subtitle)}</p>}
      </div>
      <div className="flex items-center justify-center">
        {!hideNavigationButtons && (
          <Link to="/account" viewTransition>
            <VpIcon name="settings" size={32} color={accountColor} />
          </Link>
        )}
      </div>
    </header>
  )
}

export default TopBar
